'use client'

import { trackEvent } from '@patrianna/analytics'
import { useEffect } from 'react'

import { IS_BRAND_PULSZ } from 'config/brands'
import PWAProvider from 'containers/PWAProvider'
import { useScrollToTopOnRouteChange } from 'hooks/useScrollToTopOnRouteChange'
import HomeContent from 'pageContainers/Home/components/HomeContent/Content'
import { useAppDispatch } from 'store/hooks'
import { saveBingoRooms } from 'store/modules/bingo/actions'
import { saveGamesProductsFromCategories } from 'store/modules/games/actions'

type Props = {
  categories: any
  cookies: any
  bingoRooms?: any
  providers?: any
  layout?: string
}

export default function Home(props: Props) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (props.categories?.length) {
      dispatch(saveGamesProductsFromCategories(props.categories))
    }

    if (props.bingoRooms?.length) {
      dispatch(saveBingoRooms({ rooms: props.bingoRooms }))
    }
    // eslint-disable-next-line
  }, [])

  useScrollToTopOnRouteChange()

  return (
    <>
      <HomeContent
        categories={props.categories}
        cookies={props.cookies}
        bingoRooms={props?.bingoRooms}
        providers={props?.providers}
        layout={props.layout}
      />
      <PWAProvider />
    </>
  )
}
